import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const tasksStatusesSlice = createSlice({
  name: "tasksStatuses",
  initialState: {},
  reducers: {
    setTasksStatusesData: (_state: any, action: PayloadAction<any>) =>
      action.payload.reduce((prev: Record<string, any>, curr: any) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setTasksStatusesData } = tasksStatusesSlice.actions;

export const tasksStatuses = tasksStatusesSlice.reducer;

export default tasksStatusesSlice.reducer;
